import {decodeURIComponentSafe} from '@wandb/weave/common/util/url';

/**
 * Organization names can contain reserved URL characters such as `&`. The
 * shell's `decodeURI` leaves their encoded forms, such as `%26`, intact, so
 * decode the route parameter before using it to find the organization.
 */
export function decodeOrgNameRouteParam(
  orgName: string | undefined
): string | undefined {
  if (orgName === undefined) {
    return undefined;
  }
  return decodeURIComponentSafe(orgName);
}
